// Directive v-date-fr : saisie de date "a la TransCAM" sur n'importe quel <input>.
// - au fil de la frappe : filtre les chiffres et insere les '/' (010181 -> 01/01/81)
// - a la sortie du champ (blur) : applique le pivot de siecle + valide (-> 01/01/1981)
// La valeur est reinjectee via un evenement 'input' natif => v-model / @input / :value
// se mettent a jour normalement, sans que la directive ait a connaitre le binding.
//
// Usage : <input type="text" placeholder="JJ/MM/AAAA" v-model="x" v-date-fr />
// (poser aussi sur un composant Vuetify fonctionne : on cible le <input> interne.)

import { sanitizeDateInput, normalizeDateFr } from "../script/dateFr.js";

function inputCible(el) {
    return el && el.tagName === "INPUT" ? el : (el ? el.querySelector("input") : null);
}

// Reecrit la valeur du champ et notifie le binding Vue (evenement 'input' natif).
function appliquer(input, valeur) {
    if (valeur === input.value) return;
    input.value = valeur;
    input.dispatchEvent(new Event("input", { bubbles: true }));
}

function creerHandlers(input) {
    let enCours = false; // garde-fou anti-reentrance (on redeclenche 'input' nous-memes)

    const onInput = () => {
        if (enCours) return;
        const formate = sanitizeDateInput(input.value);
        if (formate !== input.value) {
            enCours = true;
            appliquer(input, formate);
            enCours = false;
        }
    };

    const onBlur = () => {
        const norm = normalizeDateFr(input.value);
        // norm === null : saisie incomplete/invalide -> on laisse tel quel (pas de perte).
        if (norm !== null && norm !== input.value) {
            enCours = true;
            appliquer(input, norm);
            enCours = false;
        }
    };

    return { onInput, onBlur };
}

export default {
    mounted(el) {
        const input = inputCible(el);
        if (!input) return;
        const h = creerHandlers(input);
        input.addEventListener("input", h.onInput);
        input.addEventListener("blur", h.onBlur);
        el._vDateFr = { input, ...h };
    },
    unmounted(el) {
        const s = el._vDateFr;
        if (s) {
            s.input.removeEventListener("input", s.onInput);
            s.input.removeEventListener("blur", s.onBlur);
            delete el._vDateFr;
        }
    },
};
